import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function AcceptInvitation() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/auth/invitations/${token}`).then(({ data }) => setInvite(data)).catch((e) => setError(apiError(e))).finally(() => setLoading(false));
  }, [token]);

  const accept = async (e) => {
    e.preventDefault();
    if (password.length < 12) return setError("Password must be at least 12 characters");
    if (password !== confirm) return setError("Passwords do not match");
    setLoading(true); setError("");
    try {
      await api.post(`/auth/invitations/${token}/accept`, { password });
      navigate("/login", { replace: true });
    } catch (e) { setError(apiError(e)); setLoading(false); }
  };

  return <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
    <div className="w-full max-w-md bg-white border border-slate-200 rounded-sm p-7">
      <div className="font-display font-black text-2xl text-slate-900">PLSC</div>
      <h1 className="text-xl font-semibold mt-6">Accept your invitation</h1>
      {loading && !invite ? <Loader2 className="h-5 w-5 animate-spin mt-6" /> : error && !invite ? <div className="mt-5 text-sm text-red-700">{error}</div> : <>
        <p className="text-sm text-slate-600 mt-2">{invite?.name} · {invite?.email}</p>
        {invite?.login_methods?.includes("password") ? <form onSubmit={accept} className="space-y-4 mt-6">
          {error && <div className="text-sm text-red-700">{error}</div>}
          <div><Label>Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} /></div>
          <div><Label>Confirm password</Label><Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} /></div>
          <Button className="w-full bg-blue-600 hover:bg-blue-700" disabled={loading}>{loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Set password</Button>
        </form> : <Button asChild className="w-full mt-6 bg-blue-600 hover:bg-blue-700"><Link to="/login">Continue to Google sign-in</Link></Button>}
      </>}
    </div>
  </div>;
}
